import React from 'react';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/640b5a5c17d36fb7ea34f232fe0fe50f.jpg"
          alt="Spa Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-light text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Experience Ultimate Relaxation
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto font-light">
          Discover the perfect harmony of traditional Thai massage, luxurious Moroccan bath, and rejuvenating spa treatments in the heart of Dubai
        </p>

        {/* Phone Number CTA */}
        <div className="mb-8 flex flex-col items-center space-y-4">
          <a 
            href="tel:0509348676" 
            className="inline-flex items-center space-x-3 px-8 py-4 bg-white text-amber-900 rounded-full text-xl font-semibold hover:bg-amber-50 transition-all hover:scale-105 cursor-pointer shadow-lg"
          >
            <i className="ri-phone-fill text-2xl"></i>
            <span>Call Now: 0509348676</span>
          </a>
          <p className="text-white/80 text-sm">Available Mon-Sun 11:00-03:00</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-amber-900 text-white text-base font-medium rounded-full hover:bg-amber-800 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Book Appointment →
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-medium rounded-full hover:bg-white/20 transition-all hover:scale-105 whitespace-nowrap cursor-pointer border border-white/30"
          >
            View Services
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
